import axios from './axios'
import api from './api'

export default {
  install: (Vue) => {
    // 需要挂载的都放在这里
    Vue.prototype.$api = api
    Vue.prototype.$ajax = axios
    
    // 接口错误提示
    Vue.prototype.$responeFailTips = (text) => {
      Vue.prototype.$toast.fail({
        message: text,
        duration: 3000
      })
    }
    
    // 一般输入验证错误提示
    Vue.prototype.$validErrorTips = (text) => {
      Vue.prototype.$toast(text)
    }
  }
}
